import { UseDisclosureProps, useDisclosure } from '@chakra-ui/react';
import * as React from 'react';

export const usePostingExperience = (options?: {
  modal?: UseDisclosureProps;
  drawer?: UseDisclosureProps;
}): {
  isModalOpen: boolean;
  onModalClose: () => void;
  isDrawerOpen: boolean;
  onDrawerClose: () => void;
  tabIndex: number;
  onTabChange: React.Dispatch<React.SetStateAction<number>>;
  createPost: () => void;
  createPoll: () => void;
  createQuestion: () => void;
  createArticle: () => void;
} => {
  const {
    isOpen: isModalOpen,
    onClose: onModalClose,
    onOpen: onModalOpen,
  } = useDisclosure(options?.modal);
  const {
    isOpen: isDrawerOpen,
    onClose: onDrawerClose,
    onOpen: onDrawerOpen,
  } = useDisclosure(options?.drawer);
  const [tabIndex, onTabChange] = React.useState(0); // this relies on the modal component correctly having the tabs in the correct order

  return {
    isModalOpen,
    onModalClose,
    isDrawerOpen,
    onDrawerClose,
    tabIndex,
    onTabChange,
    createPost() {
      onTabChange(0);
      onDrawerClose();
      onModalOpen();
    },
    createQuestion() {
      onTabChange(1);
      onDrawerClose();
      onModalOpen();
    },
    createPoll() {
      onTabChange(2);
      onDrawerClose();
      onModalOpen();
    },
    createArticle() {
      onModalClose();
      onDrawerOpen();
    },
  };
};
